
import { RangerFirearmAssignmentLogMetadataBase } from './ranger-firearm-assignment-log.metadata.base';


export class RangerFirearmAssignmentLogMetadata extends RangerFirearmAssignmentLogMetadataBase {
  constructor() {
    super();
  }
}

export const RANGER_FIREARM_ASSIGNMENT_LOG_METADATA: RangerFirearmAssignmentLogMetadata = new RangerFirearmAssignmentLogMetadata();


